











































import Vue from "vue";
//@ts-ignore
import { AmplifyEventBus } from 'aws-amplify-vue';
import { Auth } from 'aws-amplify';

export default Vue.extend({

  name: 'AuthConfirmSignUp',
  props: {
    confirmSignUpConfig: {
      type: Object,
    },
    usernameAttributes: {
      type: String,
    },
    confirmationCode: {
      type: String
    },
    confirmationUsername: {
      type: String
    }
  },

  data() {
    return {
      error: '',
      busy: false
    }
  },
  computed: {
    options(): any {
      const defaults = {
        username: ''
      };
      return Object.assign(defaults, this.confirmSignUpConfig || {})
    },
    isVerification(): boolean {
      if (!!this.confirmationCode && !!this.confirmationUsername) {
        return true;
      }
      return false;
    }
  },
  mounted() {
    if (this.isVerification) {
      let clientMetadata = {
        "requestFromAddress": window.location.href.split('?')[0],
        "packageId": "SANO"
      };
      Auth.confirmSignUp(this.confirmationUsername, this.confirmationCode, {clientMetadata: clientMetadata})
        .then(value => {

        })
        .catch(e => this.setError(e));
    } else if (!this.options.username) {
      this.setError('Valid username not received.');
    }
  },
  methods: {
    signIn: function () {
      this.error = '';
      AmplifyEventBus.$emit('authState', 'signIn')
    },
    resend() {
      this.error = '';
      this.busy = true;
      // Pass client meta data as it is used by the backend to customize the message.
      var clientMetadata = {
        "requestFromAddress": window.location.href.split('?')[0],
        "packageId": "SANO"
      };
      Auth.resendSignUp(this.options.username, clientMetadata)
        .then(response => this.busy = false)
        .catch((e: any) => {
          this.setError(e);
          this.busy = false;
        });
    },
    setError(e: any) {
      this.error = e.message || e;
    },
  }
});
